import * as React from "react";

import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

import ReactTable from "react-table";
import { Column } from "react-table";
import "react-table/react-table.css";
import i18n from "../i18n";
import { getAsync } from "utils/net";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface ScenarioHistoryProps {
  isOpen: boolean;
  scenarioName: string;
  onClose: () => void;
  onLoadHistory: (historyItem: any) => void;
}
export interface ScenarioHistoryState {
  history: any[];
}

export default class ScenarioHistory extends React.Component<
  ScenarioHistoryProps,
  ScenarioHistoryState
> {
  constructor(props: ScenarioHistoryProps) {
    super(props);
    this.state = {
      history: []
    };
  }

  async componentDidUpdate(prevProps: ScenarioHistoryProps) {
    if (
      this.props.isOpen &&
      (prevProps.scenarioName !== this.props.scenarioName || !prevProps.isOpen)
    ) {
      const reply = await getAsync(
        `/api/designer/getscenarioshistory?scenarioName=${
          this.props.scenarioName
        }`
      );
      const history = await reply.json();
      this.setState({
        history
      });
    }
  }

  private formatDate(d: Date) {
    if (d) {
       // tslint:disable-next-line:max-line-length
       return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
    } else {
       return "";
    }
  }

  private filterMethod = (filter: any, row: any) =>
    new RegExp(filter.value, "i").test(String(row[filter.id]));

  private columns: Column[] = [
    {
      Header: i18n.Scenarios.History.Author,
      id: "author",
      accessor: (value: any) => value.changedBy
      },
      {
          Header: i18n.Scenarios.History.Languages,
          id: "languages",
          accessor: (value: any) => value.languages
      },
    {
      Header: i18n.Scenarios.History.Timestamp,
      id: "timestamp",
      accessor: (row: any) => row._ts ? new Date(row._ts * 1000) : null,
      Cell: (row: any) => <span>{this.formatDate(row.value)}</span>
  },
    {
      Header: i18n.Scenarios.History.View,
      filterable: false,
      maxWidth: 50,
      Cell: row => (
        <Button
          size="sm"
          color="primary"
          onClick={() => this.props.onLoadHistory(row.original)}
        >
          <FontAwesomeIcon icon={faEye} />
        </Button>
      )
    }
  ];
  render() {
    const { isOpen } = this.props;
    const { history } = this.state;
    return (
      <Modal isOpen={isOpen} size="lg">
        <ModalHeader>{i18n.Scenarios.History.Title}</ModalHeader>
        <ModalBody>
          {isOpen && (
            <ReactTable
              data={history}
              columns={this.columns}
              defaultFilterMethod={this.filterMethod}
              defaultPageSize={10}
              defaultSorted={[
                {
                  id: "timestamp",
                  desc: true
                }
              ]}
              className="-striped -highlight"
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primar" onClick={() => this.props.onClose()}>
            {i18n.Global.Close}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/designer/show-history.tsx